/*  MUI  */
import { Box, Grid, TableCell } from '@mui/material';

/*  Shared  */
import { ApplicationNameLinkCell } from 'application/Shared/Components/ApplicationNameLinkCell';
import { SSOSupportIcons } from 'application/Shared/Components/SSOSupportIcons';
import { ManagedTable } from 'application/Shared/Components/Table';
import { FontSizes } from 'application/Shared/Constants';

/*  Objects  */
import { Application } from 'objects/Application';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

const RenderRow = ({ row }) => (
    <TableCell>
        <Grid container spacing={0} alignItems="center">
            <Grid item xs={6}>
                <Application data={row.application} nameHasLink>
                    <ApplicationNameLinkCell nameNoTruncate />
                </Application>
            </Grid>
            <Grid item xs={6}>
                <SSOSupportIcons
                    ssoSupport={row.ssoSupport}
                    enableTooltip
                    tenantApp={row}
                    justify="left"
                />
            </Grid>
        </Grid>
    </TableCell>
);

const headers = [
    {
        align: 'left',
        field: 'application',
        renderHeader: <strong>Entries</strong>,
        width: '50%'
    },
    {
        align: 'left',
        field: 'ssoSupport',
        renderHeader: <strong>Entries2</strong>,
        width: '50%'
    }
];

export const SSOCoverage = ({ tenantApps }) => {
    const { t } = useTranslation();
    const filteredApps = tenantApps?.filter(
        (app) =>
            app?.ssoSupport?.length &&
            !app.azureSignInDetected &&
            !app.microsoftSSODetected &&
            !app.googleSignInDetected &&
            !app.googleSSODetected
    );

    const showData = filteredApps?.length > 0;

    return showData ? (
        <Box sx={{ width: '100%' }}>
            <ManagedTable
                headers={headers}
                renderBody={(row) => <RenderRow row={row} />}
                renderFooter
                renderHeaderRow={false}
                rowHeight={10}
                rows={filteredApps}
                rowsPerPage={5}
                sortDirection="DESC"
                sortFieldType="number"
                sortKey="usage"
            />
        </Box>
    ) : (
        <Box
            data-testid="ssoCoverageNoData"
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
            minHeight="250px"
            sx={{
                color: 'text.cardKPINoData',
                fontSize: FontSizes[2],
                textAlign: 'center'
            }}
        >
            {t('Common.noData')}
        </Box>
    );
};
